import { useAppSelector } from 'hooks/reduxHooks'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'

/**
 * Returns the appropriate tier to display for the double points campaign
 * - If user has loyalty account: shows next tier (or current if platinum)
 * - If user doesn't have account: shows base tier
 */
function useDoublePointsCampaignTier(): App.LoyaltyTier {
  const [tier, , nextTier] = useCurrentLoyaltyTier()
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)

  return hasLoyaltyAccount ? nextTier ?? tier : tier
}

export default useDoublePointsCampaignTier
